import React, { useState } from "react";
import axios from "axios";
import "../Styling/NewHireDashboardNavi1.css";

export default function NewHireDashboard() {
  const candidates = [
    {
      name: "Yogendra Kumar",
      id: "IND-1023",
    },
    {
      name: "John Mathew",
      id: "IND-1023",
    },
    {
      name: "John Mathew",
      id: "IND-1023",
    },
  ];

  const [selected, setSelected] = useState(0);

  //for search//
  const [search, setSearch] = useState("");

  /* FILTER */
  const filteredCandidates = candidates.filter((c) =>
    c.name.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="NewHireDashboard-container">
   
      {/* LEFT PANEL */}
      <div className="left-panel">
        <div className="panel-header">Select Candidates</div>

        <div className="search-box">
          <input placeholder="🔍 Search by name...."  value={search}
          onChange={(e) => setSearch(e.target.value)} />
        </div>

        {/* <div className="candidate active">
          <b>John Mathew</b>
          <p>Induction No. = IND-1023</p>
        </div>

        <div className="candidate">
          <b>John Mathew</b>
          <p>Induction No. = IND-1023</p>
        </div>

        <div className="candidate">
          <b>John Mathew</b>
          <p>Induction No. = IND-1023</p>
        </div> */}

        {filteredCandidates.map((c, index) => (
          <div
            key={index}
            className={selected === index ? "candidate active" : "candidate"}
            onClick={() => setSelected(index)}
          >
            <b>{c.name}</b>

            <div className="small">Induction No. = {c.id}</div>
          </div>
        ))}

      </div>


      {/* RIGHT PANEL */}

      <div className="right-panel">
        <div className="panel-header">New Hire – Pre-Joining</div>

        <div className="cards-grid">
          {/* Card 1 */}

          <div className="card pink">
            <h3>Personal Info</h3>

            <p>Name: Yogendra Kumar</p>

            <p>Rank: Able Seaman</p>
          </div>

          {/* Card 2 */}

          <div className="card orange">
            <h3>CDC Details</h3>

            <p>CDC No. CDC890245</p>

            <p>Issue Date: 16 Mar 2023</p>
          </div>

          {/* Card 3 */}

          <div className="card teal">
            <h3>Passport Details</h3>

            <p>Passport No.: P1534</p>

            <p>Expiry Date: 14 Aug 2027</p>
          </div>

          {/* Card 4 */}

          <div className="card green">
            <h3>Document Status</h3>

            <div className="status">All Document valid</div>
          </div>
        </div>
      </div>
    </div>
  );
}
